import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import parse from 'html-react-parser';
const Alert = ({ type, description, title }) => {
    const iconBg = useMemo(() => {
        if (type === 'error') {
            return 'error-red';
        }
        if (type === 'warning') {
            return 'yellow';
        }
        return 'accent';
    }, [type]);
    const iconColor = type === 'error' ? 'light' : 'dark';
    const iconClass = `bg-${iconBg} text-${iconColor}`;
    return (_jsxs("div", { className: "bg-gray-extra-light mb-3 mt-4 p-3", role: "alert", children: [_jsxs("div", { className: `d-flex ${title ? 'align-items-center' : ''}`, children: [_jsx("i", { className: `nbw-icon nbw-icon-exclamation-mark circle-icon circle-icon-small text-light bg-dark border border-accent mr-3 ${iconClass}` }), title && _jsx("div", { className: "font-weight-bold font-size-extra-large", children: title }), !title && _jsx("div", { className: "font-size-small", children: parse(description) })] }), title && _jsx("div", { className: "font-size-small mt-3", children: parse(description) })] }));
};
export default Alert;
